import { Typography } from '@material-ui/core';
import { RenderHtml, GiftCard } from '@flos/react-components';
import { baseStyles } from '../../theme/base.styles';
import { useEffect, useState } from 'react';
import { useGlobalDispatch, useGlobalState } from '../../common/context/AppContext';
import track, { errorTypes } from 'c9-tracking';
import { fetchGiftCardDetails } from '../../common/async/AsyncCalls';
import { IAppProps } from '../../common/interface/IAppProvider';

export const HouseholdText = (props: IAppProps): JSX.Element => {
  const content = props.config.resourceBundles['onsa.travel.household'].read();
  const cb_iwc1 = props.config.contentBlocks['onsa.travel.intro-wo-content-1'].read();
  const baseClasses = baseStyles();
  const { giftCard } = useGlobalState();
  const [isWaiting, setIsWaiting] = useState(false);
  const appDispatch = useGlobalDispatch();

  useEffect(() => {
    if (giftCard === null && !isWaiting) {
      setIsWaiting(true);
      fetchGiftCardDetails(props, appDispatch)
        .then((response) => {
          track.info([{ key: 'gift card status for travel: ', value: response?.status }]);
          appDispatch({ giftCard: response, stateChange: true });
        })
        .catch(() => track.fault('get gift card status for travel failed', errorTypes.tech, 'giftCard'))
        .finally(() => setIsWaiting(false));
    }
  }, [giftCard, props, appDispatch, isWaiting]);

  const renderGiftCardIntro = () => {
    if (giftCard?.status === 'active') {
      return (
        <>
          {content.giftcardintro ? (
            <RenderHtml
              html={content.giftcardintro.replace('{amount}', giftCard.amount)}
              className={baseClasses.htmlWrapper}
            />
          ) : (
            <></>
          )}

          <GiftCard productType="TRAVEL" amount={giftCard.amount} campaign={giftCard.campaign} />
        </>
      );
    }
  };

  return (
    <>
      <RenderHtml html={cb_iwc1.data} className={baseClasses.htmlWrapper} />
      {renderGiftCardIntro()}
      <Typography variant="subtitle1" color="textPrimary" paragraph className={baseClasses.spacingLarge}>
        {content.message0}
      </Typography>
      <Typography variant="subtitle1" color="textPrimary" paragraph>
        {content.message1}
      </Typography>
    </>
  );
};
